export default __webpack_public_path__ + "e78e24c0dea8d14b02fd3dc9d920d9a9.woff";